<template>
  <div>
    <!-- 企业描述 start -->
    <a-card
      class="mt-20"
      :bordered="false"
    >
      <div class="tenant-card">
        <a-avatar
          class="logo"
          shape="square"
          :size="200"
          :src="tenant.logo"
          alt="企业logo"
        />
        <div class="name">{{ tenant.name }} <a-tag color="orange" class="ml-10">{{ tenant.code_type_str }}</a-tag>
        </div>
        <div class="f16">
          <label>云码数量：</label>
          <span class="red">{{ tenant.code_type==='NORMAL'?tenant.security_code_balance:'可无限使用' }}</span>
          <a-button
            v-if="tenant.code_type==='NORMAL'"
            type="primary"
            class="ml-20"
            size="small"
            @click="handleRecharge"
          >充值</a-button>
        </div>
        <div class="f16">
          <label>到期时间：</label>
          <span class="red">{{ tenant.expiry_time }}</span>
          <a-button
            type="primary"
            size="small"
            class="ml-20"
            @click="handleAnnual"
          >续费</a-button>
        </div>
        <div class="f16 gray">累计充值数量：<span class="red">{{ tenant.security_code_count }}</span> &nbsp;&nbsp; 累计充值金额：<span class="red">￥{{ tenant.security_code_money }}</span></div>
      </div>
    </a-card>
    <!-- 企业描述 end -->
    <a-card
      class="mt-20"
      :bordered="false"
    >
      <!-- 表格筛选 start -->
      <a-form layout="inline">
        <a-form-item class="mr-20">
          <a-select
            allowClear
            placeholder="状态"
            v-model="queryParam.status"
            style="width: 180px"
          >
            <a-select-option
              v-for="item in dict.statusDict"
              :key="item.id"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- 时间 -->
        <a-form-item class="mr-20">
          <a-range-picker v-model="querytimeRange" />
        </a-form-item>
        <a-form-item>
          <a-button
            class="mr-10"
            type="primary"
            @click="handleFilter"
          >
            搜索
          </a-button>
          <a-button @click="handleReset">
            重置
          </a-button>
        </a-form-item>
      </a-form>
      <!-- 表格筛选 end -->
      <!-- 表格内容操作 start -->
      <div class="mt-20">
        <a-button
          type="primary"
          class="mr-20"
          @click="handleExport"
        >导出</a-button>
      </div>
      <!-- 表格内容操作 end -->
      <!-- 表格 start TODO表格报错？？？ -->
      <tcg-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        bordered
        class="mt-20"
      >
        <span
          slot="orderId"
          slot-scope="text"
          style="word-break: break-all !important;"
        >
          {{ text }}
        </span>
        <span
          slot="order_type"
          slot-scope="text"
        >
          {{ text | valInDict(dict.orderTypeDict) }}
        </span>
        <span
          slot="status"
          slot-scope="text"
        >
          <a-tag :color="text | statusTagFilter">
            {{ text | valInDict(dict.statusDict) }}
          </a-tag>
        </span>
        <span
          slot="action"
          slot-scope="text, record"
        >
          <a-button
            type="link"
            @click="handleLook(record.orderId, record.order_type)"
          >查看</a-button>
          <a-button
            v-if="record.status==='NORMAL'"
            type="link"
            @click="handlePay(record)"
          >支付</a-button>
          <a-button
            v-if="record.status==='NORMAL'"
            type="link"
            @click="handleCancelOrder(record.orderId, record.order_type)"
          >取消订单</a-button>
        </span>
      </tcg-table>
      <!-- 表格 end -->
    </a-card>
    <!-- 支付面板弹框 -->
    <pay-panel
      ref="payPanel"
      :price="curItem.total_price"
      :orderType="curItem.order_type"
      :defaultPayType="curItem.pay_type"
      @close="handleClosePayPanel"
    />
    <!-- 创建订单弹框 -->
    <property-order-modal
      ref="PropertyOrderModal"
      @ok="handlePay"
    />
    <!-- 订单详情弹框 -->
    <order-detail-modal ref="OrderDetailModal" />
  </div>
</template>

<script>
import { TcgTable } from '@/components'
import PayPanel from '@/components/PayPanel'
import PropertyOrderModal from '@/components/PropertyOrderModal'
import OrderDetailModal from './components/OrderDetailModal'
import { getPropertypre, getTenant, postCancalOrder, getPropertyOrderList } from '@/api/print'
import { downloadFile } from '@/utils'

const defaultQueryParam = {}

export default {
  name: 'PropertyManageIndex',
  components: { TcgTable, PayPanel, PropertyOrderModal, OrderDetailModal },
  data() {
    return {
      tenant: {},
      querytimeRange: [], // 选择时间
      queryParam: Object.assign({}, defaultQueryParam),
      // 字典
      dict: {
        statusDict: [],
        orderTypeDict: []
      },
      curItem: {
        // {
        //   total_price: total_price,
        //   order_type: order_type,
        //   orderId: orderId
        // }
      },
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderId',
          scopedSlots: { customRender: 'orderId' }
        },
        {
          title: '订单类型',
          dataIndex: 'order_type',
          scopedSlots: { customRender: 'order_type' }
        },
        {
          title: '订单金额（元）',
          dataIndex: 'total_price'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '最后更新时间',
          dataIndex: 'update_time'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'id',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      loadData: (parameter) => {
        if (this.querytimeRange.length) {
          this.queryParam.start_time = this.querytimeRange[0].format('YYYY-MM-DD')
          this.queryParam.end_time = this.querytimeRange[1].format('YYYY-MM-DD')
        } else {
          this.queryParam.start_time = null
          this.queryParam.end_time = null
        }
        return getPropertyOrderList(Object.assign(parameter, this.queryParam)).then((res) => {
          return res
        })
      }
    }
  },
  created() {
    this.getPre()
    this.getTenant()
  },
  methods: {
    handleFilter() {
      this.$refs.table.refresh(true)
    },
    handleReset() {
      this.queryParam = Object.assign({}, defaultQueryParam)
      this.querytimeRange = []
      this.$refs.table.refresh(true)
    },
    // 获取商户信息
    getTenant() {
      getTenant()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.tenant = data
          }
        })
        .catch((e) => {
          this.$message.error('获取商户信息失败')
        })
    },
    // 预加载
    getPre() {
      getPropertypre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.dict.statusDict = data.statusDict
            this.dict.orderTypeDict = data.orderTypeDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    },
    // 查看
    handleLook(orderId, orderType) {
      this.$refs.OrderDetailModal.showModal(orderId, orderType)
    },
    // 取消订单
    handleCancelOrder(orderId, order_type) {
      this.$confirm({
        title: '确定要取消订单?',
        onOk: () => {
          this.confirmLoading = true
          postCancalOrder({
            order_type: order_type,
            orderId: orderId
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('取消订单成功')
                this.handleFilter()
              }
            })
            .catch((e) => {
              this.$message.error('取消订单失败')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    // 支付
    handlePay(item) {
      // {
      //   total_price: total_price,
      //   order_type: order_type,
      //   orderId: orderId
      // }
      this.curItem = Object.assign({}, item)
      this.$refs.payPanel.showModal(item.orderId)
    },
    // 导出
    handleExport() {
      // window.location.href = window.location.origin + '/merchant.php/property/outExcel'
      const href = window.location.origin + '/merchant.php/property/outExcel'
      downloadFile(href)
    },
    // 充值
    handleRecharge() {
      this.$refs.PropertyOrderModal.showModal('RECHARGE')
    },
    // 续费
    handleAnnual() {
      this.$refs.PropertyOrderModal.showModal('ANNUAL')
    },
    // 关闭支付弹框
    handleClosePayPanel() {
      this.handleFilter()
      this.getTenant()
    }
  }
}
</script>

<style lang="less" scoped>
.tenant-card {
  line-height: 50px;
  .logo {
    float: left;
    margin-right: 40px;
  }
  .name {
    font-size: 20px;
    font-weight: bolder;
  }
  .f16 {
    font-size: 16px;
  }
  .f12 {
    font-size: 12px;
  }
  .fwb {
    font-weight: bolder;
  }
  .gray {
    color: #cccccc;
  }
}
</style>
